import {radii, tokens} from '@commercial-helios/ui/theme'
import React from 'react'
import styled from 'styled-components'

import FeatureBlock from '@/components/feature-block'
import {download} from '@/utils/download'
import Button from '@helios/shared/components/button'
import type {Props as PrismicLinkProps} from '@helios/shared/components/prismic-link'
import PrismicLink from '@helios/shared/components/prismic-link'
import type ImageSource from '@helios/shared/types/image'
import {track, TrackingEvent} from '@helios/shared/utils/analytics'
import mq from '@helios/shared/utils/media-query'

import {BREAKPOINT_SM} from '../constants'
import type {ExpenseReportGeneratorVariant} from '../types'

interface Props {
    image: ImageSource
    title: string
    body: string
    downloadReportButtonText: string
    explorePleoButtonText: string
    explorePleoButtonLink: PrismicLinkProps
    shareableLink: string
    variant: ExpenseReportGeneratorVariant
}

const SuccessScreen = (props: Props) => {
    const [loading, setLoading] = React.useState(false)

    React.useEffect(() => {
        track(TrackingEvent.ERGActioned, {
            action: 'success_step_reached',
            variant: props.variant,
        })
    }, [props.variant])

    const handleDownloadExpenseReport = async () => {
        setLoading(true)
        await download(props.shareableLink)

        setLoading(false)

        track(TrackingEvent.ERGActioned, {
            action: 'pdf_downloaded',
            variant: props.variant,
        })
    }

    return (
        <SuccessScreenWrapper>
            <FeatureBlock {...props} titleVariant="title-base" mirrored>
                <ButtonsWrapper>
                    {props.variant === 'internal' && (
                        <Button onClick={handleDownloadExpenseReport} loading={loading}>
                            {props.downloadReportButtonText}
                        </Button>
                    )}

                    <Button as={PrismicLink} {...props.explorePleoButtonLink} variant="outline">
                        {props.explorePleoButtonText}
                    </Button>
                </ButtonsWrapper>
            </FeatureBlock>
        </SuccessScreenWrapper>
    )
}

const SuccessScreenWrapper = styled.div`
    padding: ${tokens.spacing40};
    background: ${tokens.shade000};
    border-radius: ${radii.arc8};

    ${mq.max(BREAKPOINT_SM)} {
        padding: 0;
        background: none;
    }
`

const ButtonsWrapper = styled.div`
    display: grid;
    gap: ${tokens.spacing20};
    width: 100%;

    ${mq.min('md')} {
        grid-auto-flow: column;
        width: auto;
    }
`

export default SuccessScreen
